app.controller('CommentWindowController', ['$scope', 'params', 'DocumentsService', 'OrganizationalUnit', 'usSpinnerService', "$uibModalInstance",
    function ($scope, params, DocumentsService, OrganizationalUnit, usSpinnerService, $uibModalInstance) {
        $scope.action = params.action;
        $scope.header = params.header;
        $scope.actionCommentIsForStudent = false;
        $scope.isForStudent = params.isForStudent;
        $scope.comment = params.comment;
        $scope.author = null;

        if(params.comment && params.comment.author) {
            DocumentsService.getEmployee(params.comment.author).then(function (emp) {
                $scope.author = emp;
            });
        }

        $scope.save = function () {
            if ($scope.action === 'setTopic' && !$scope.comment) return;
            $uibModalInstance.close({
                comment: $scope.comment,
                actionCommentIsForStudent: $scope.actionCommentIsForStudent
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }]);
